<template>
  <a-select ref="select"
            :value="innerValue"
            allowClear
            :filterOption="handleSelectFilterOption"
            v-bind="selectProps"
            style="width: 100%;"
            @blur="handleBlur"
            @popupScroll="handlePopupScroll"
            @change="handleChangeCommon"
            @search="handleSelectSearch">
    <!-- 禁用下拉框时不进行数据分页 -->
    <template v-if="selectProps.disabled">
      <template v-for="option in optionData">
        <a-select-option :key="option.value" :value="option.value" :disabled="option.disabled">
          <span>{{ option.text || option.label || option.title || option.value }}</span>
        </a-select-option>
      </template>
    </template>
    <template v-else>
      <template v-for="option in getOption()">
        <a-select-option :key="option.value" :value="option.value" :disabled="option.disabled">
          <span>{{ option.text || option.label || option.title || option.value }}</span>
        </a-select-option>
      </template>
    </template>
  </a-select>
</template>

<script>
import JVxeCellMixins, { dispatchEvent } from '@/components/jeecg/JVxeTable/mixins/JVxeCellMixins'
import { JVXETypes } from '@comp/jeecg/JVxeTable/index'

export default {
  name: 'JVxeSelectCell',
  mixins: [JVxeCellMixins],
  data() {
    return {
      // 截取数目，可变
      loadNum: 20,
      // 截取前的mmCode
      oriDataList: [],
      // 搜索内容
      searchVal: '',
      // 搜索后显示的内容
      renderedOptions: [],
      filterDataList: []
    }
  },
  computed: {
    selectProps() {
      let props = { ...this.cellProps }
      // 判断select是否允许输入
      // let { allowSearch, allowInput } = this.originColumn
      // if (allowInput === true || allowSearch === true) {
      //   props[ 'showSearch' ] = true
      // }
      props[ 'showSearch' ] = true
      return props
    }
  },
  created() {
    let multiple = [JVXETypes.selectMultiple, JVXETypes.list_multi]
    let search = [JVXETypes.selectSearch, JVXETypes.sel_search]
    if (multiple.includes(this.$type)) {
      // 处理多选
      let props = this.originColumn.props || {}
      props[ 'mode' ] = 'multiple'
      props[ 'maxTagCount' ] = 1
      this.$set(this.originColumn, 'props', props)
    } else if (search.includes(this.$type)) {
      // 处理搜索
      this.$set(this.originColumn, 'allowSearch', true)
    }
  },
  methods: {
    // 下拉框滚动事件，懒加载
    handlePopupScroll(e) {
      const { target } = e
      // target.scrollTop + target.offsetHeight === target.scrollHeight  判断是否滑动到底部
      if (Math.ceil(target.scrollTop) + target.offsetHeight === target.scrollHeight) {
        // 在这里调用接口
        if (this.searchVal === '') {
          this.loadMoreData(this.oriDataList)
        } else {
          this.loadMoreData(this.filterDataList)
        }
      }
    },
    // 下拉加载更多内容
    loadMoreData(dataList) {
      const renderedLen = this.renderedOptions.length || this.loadNum // 已渲染的下拉列表长度
      const totalLen = dataList.length // 当前数据源的长度
      let addList = []
      if (renderedLen < totalLen) {
        if (renderedLen + this.loadNum <= totalLen) {
          addList = dataList.slice(renderedLen, renderedLen + this.loadNum)
        } else {
          addList = dataList.slice(renderedLen, renderedLen + (totalLen % this.loadNum))
        }
        this.renderedOptions =
          this.renderedOptions && this.renderedOptions.length
            ? this.renderedOptions.concat(addList)
            : this.oriDataList.slice(0, this.loadNum).concat(addList)
      }
    },
    // 下拉框搜索功能
    handleSelectSearch(val) {
      // this.searchVal = val
      let filterList = this.oriDataList
      if (val !== this.searchVal) {
        filterList = this.oriDataList.filter(option => {
          let str = option.text || option.label || option.title || option.value
          return str.indexOf(val) > -1
        })
      }
      this.searchVal = val
      this.filterDataList = filterList
      this.renderedOptions = filterList.length < this.loadNum ? filterList : filterList.slice(0, this.loadNum)
    },
    getOption() {
      let renderedOptions = []
      let options = this.setOptionData()
      if (options && options.length > 0) {
        if (this.oriDataList.length && this.oriDataList.length !== options.length) {
          this.renderedOptions = []
          this.searchSelectValues = {}
        }
        this.oriDataList = options
        renderedOptions =
          this.renderedOptions && this.renderedOptions.length
            ? this.renderedOptions
            : this.oriDataList.slice(0, this.loadNum)
        // console.log('4', renderedOptions)
        return renderedOptions
      } else {
        this.renderedOptions = []
        return []
      }
    },
    // 根据不同情况计算出下拉框源数据
    setOptionData() {
      // 子表每行下拉框数据源不一样情况取值
      let arr = this.renderOptions.optionData[ `row-${this.rowIndex}` ]
      if (arr && arr.length) return arr
      // 子表每行下拉框数据源一样情况取值
      if (this.originColumn.options.length) return this.originColumn.options
      return []
    },
    /** 处理blur失去焦点事件 */
    handleBlur(value) {
      let { allowInput, options } = this.originColumn
      if (allowInput === true) {
        // 删除无用的因搜索（用户输入）而创建的项
        if (typeof value === 'string') {
          let indexes = []
          options.forEach((option, index) => {
            if (option.value.toLocaleString() === value.toLocaleString()) {
              delete option.searchAdd
            } else if (option.searchAdd === true) {
              indexes.push(index)
            }
          })
          // 翻转删除数组中的项
          for (let index of indexes.reverse()) {
            options.splice(index, 1)
          }
        }
      }
      this.handleBlurCommon(value)
    },
    /** 用于搜索下拉框中的内容 */
    handleSelectFilterOption(input, option) {
      let { allowSearch, allowInput } = this.originColumn
      if (allowSearch === true || allowInput === true) {
        //update-begin-author:taoyan date:20200820 for:【专项任务】大连项目反馈行编辑问题处理 下拉框搜索
        return option.componentOptions.children[ 0 ].children[ 0 ].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        //update-end-author:taoyan date:20200820 for:【专项任务】大连项目反馈行编辑问题处理 下拉框搜索
      }
      return true
    },
    /** select 搜索时的事件，用于动态添加options */
    handleSearchSelect(value) {
      let { allowSearch, allowInput, options } = this.originColumn
      if (allowSearch !== true && allowInput === true) {
        // 是否找到了对应的项，找不到则添加这一项
        let flag = false
        for (let option of options) {
          if (option.value.toLocaleString() === value.toLocaleString()) {
            flag = true
            break
          }
        }
        // !!value ：不添加空值
        if (!flag && !!value) {
          // searchAdd 是否是通过搜索添加的
          options.push({ title: value, value: value, searchAdd: true })
        }
      }
    }
  },
  // 【组件增强】注释详见：JVxeCellMixins.js
  enhanced: {
    aopEvents: {
      editActived: event => dispatchEvent(event, 'ant-select')
    },
    translate: { enabled: true },
    getValue(value) {
      if (Array.isArray(value)) {
        return value.join(',')
      } else {
        return value
      }
    },
    setValue(value) {
      let { column: { own: col }, params: { $table } } = this
      // 判断是否是多选
      if ((col.props || {})[ 'mode' ] === 'multiple') {
        $table.$set(col.props, 'maxTagCount', 1)
      }
      if (value != null && value !== '') {
        if (typeof value === 'string') {
          return value === ''? []: value.split(',')
        }
        return value
      } else {
        return undefined
      }
    }
  }
}
</script>

<style scoped>

</style>